// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.polar-container {
  display: table-cell;
  vertical-align: middle;
  justify-content: center;
  align-items: center;
  height: 100%;
}

  
.polar-content {
    text-align: center; /* center the text */
}

.svg_icons {
  transform: scale(1.5);
}

.polar-box {
  border-radius:0;
  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important;
}

@media only screen and (max-width: 600px) {
  .MuiFormControl-root {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/polar-css.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;;AAGA;IACI,kBAAkB,EAAE,oBAAoB;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sEAAsE;AACxE;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".polar-container {\r\n  display: table-cell;\r\n  vertical-align: middle;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n}\r\n\r\n  \r\n.polar-content {\r\n    text-align: center; /* center the text */\r\n}\r\n\r\n.svg_icons {\r\n  transform: scale(1.5);\r\n}\r\n\r\n.polar-box {\r\n  border-radius:0;\r\n  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important;\r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n  .MuiFormControl-root {\r\n    display: none;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
